import Actions                 from 'Redux/Actions';
import { OrganizerRepository } from 'Domain/Repositories';
import { ofType }              from 'redux-observable';
import { from }                from 'rxjs';
import { mergeMap }            from 'rxjs/operators';
import { TEpic }               from 'Redux/Config';

export const searchOrganizersEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.searchOrganizersRequest.type),
    mergeMap(action => from(
      OrganizerRepository.findAll(action.payload)
        .then(({ organizers, meta }) => Actions.searchOrganizersSuccess({ organizers, maxCount: meta?.count }))
        .catch((error: Error) => Actions.searchOrganizersFailure({ error })),
    )),
  );
};
